import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  EventEmitter,
  Input,
  Output,
  signal,
} from '@angular/core';

@Component({
  selector: 'app-cta-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cta-button.component.html',
  styleUrl: './cta-button.component.scss',
})
export class CtaButtonComponent {
  private _type = signal('button');
  private _disabled = signal(false);
  private _variant = signal<
    | 'normal'
    | 'plain'
    | 'success'
    | 'secondary'
    | 'round'
    | 'link'
    | 'light'
    | 'white'
  >('normal');
  private _loading = signal(false);
  private _color = signal('');
  private _minHeightDisabled = signal(false);
  private _size = signal<'small' | 'medium' | 'large'>('medium');

  @Input() set type(v: string) {
    this._type.set(v);
  }

  @Input() set minHeightDisabled(v: boolean) {
    this._minHeightDisabled.set(v);
  }

  @Input() set disabled(v: boolean) {
    this._disabled.set(v);
  }

  @Input() set variant(
    v:
      | 'normal'
      | 'plain'
      | 'success'
      | 'secondary'
      | 'round'
      | 'link'
      | 'light'
      | 'white',
  ) {
    this._variant.set(v);
  }

  @Input() set color(v: 'primary') {
    this._color.set(v);
  }

  @Input() set loading(v: boolean) {
    this._loading.set(v);
  }

  @Input() set size(v: 'small' | 'medium' | 'large') {
    this._size.set(v);
  }

  @Output() clicked = new EventEmitter<Event>();

  public handleClick(event: Event): void {
    this.clicked.emit(event);
  }

  disabledSig = computed(() => this._disabled());
  typeSig = computed(() => this._type());
  variantSig = computed(() => this._variant());
  loadingSig = computed(() => this._loading());
  colorSig = computed(() => this._color());
  sizeSig = computed(() => this._size());
  minHeightDisabledSig = computed(() => this._minHeightDisabled());
}
